// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.auth .title-section {
  color: var(--sebrae-gray);
  font-size: 19px;
  font-weight: 700;
  line-height: 1.2;
  margin-bottom: 16px;
}
.auth .highlight {
  position: relative;
  width: 100%;
  display: flex;
  justify-content: center;
  align-items: flex-end;
}
.auth .highlight__img {
  max-height: 603px;
  overflow: hidden;
}
.auth .highlight__img img {
  min-height: 202px;
  object-fit: cover;
}
.auth .highlight__logo {
  position: absolute;
  bottom: -24px;
  z-index: 1;
  max-width: 290px;
}
.auth .call-for-access {
  padding: 50px 0 40px;
}
.auth .call-for-access h2 {
  color: var(--sebrae-lilac);
  font-size: 16px;
  line-height: 1.2;
}
.auth .call-for-access .BaSe--grid {
  align-items: center;
}
.auth .call-for-access .BaSe--button {
  max-width: 327px;
}
.auth .call-for-access .BaSe--button span {
  font-size: 16px;
  font-weight: 700;
}
.auth .mockup-finances {
  color: var(--sebrae-gray);
  padding-bottom: 8px;
}
.auth .mockup-finances p {
  font-size: 13px;
  line-height: 1.2;
  margin-bottom: 24px;
}
.auth .mockup-finances .container {
  display: flex;
  align-items: center;
  flex-direction: column;
  padding: 0 24px;
}
.auth .mockup-finances .container .info-mockup figure {
  display: flex;
  justify-content: center;
}
.auth .mockup-finances .container .info-mockup__text-area h2 {
  display: none;
}
.auth .wrapper-cards {
  padding: 40px 0 48px;
}
.auth .carousel {
  margin-bottom: 49px;
}
.auth .carousel.mobile {
  margin: 0 -16px;
}
.auth .carousel.mobile .card-projected {
  margin: 0 10px 15px;
  min-height: 240px;
}
.auth .carousel.mobile .slick-slide:first-of-type .card-projected {
  margin-left: 16px;
}
.auth .carousel.desktop {
  display: none;
  gap: 24px;
}
.auth .wrapper-fampe .fampe {
  margin-bottom: 24px;
}
.auth .wrapper-fampe .fampe figure {
  margin-bottom: 16px;
}
.auth .wrapper-fampe .fampe .text {
  position: relative;
  width: calc(100% - 8px);
  background-color: var(--sebrae-dark-green);
  height: auto;
  padding: 16px 15px;
  margin-left: 8px;
  margin-bottom: 8px;
  color: var(--sebrae-white);
}
.auth .wrapper-fampe .fampe .text p {
  font-size: 13px;
  margin-bottom: 20px;
  line-height: 1.2;
}
.auth .wrapper-fampe .fampe .text a {
  color: inherit;
  font: inherit;
  text-decoration: underline;
}
.auth .wrapper-fampe .fampe .text:before {
  content: "";
  position: absolute;
  z-index: -1;
  top: 8px;
  left: -8px;
  width: 100%;
  height: 100%;
  border: 1px solid var(--sebrae-light-green3);
  display: block;
}
.auth .wrapper-fampe .learn-more {
  width: 90%;
  border: 1px solid var(--sebrae-lilac);
  padding: 15px;
  transform: skewX(-10deg);
  margin: 47px auto 0;
}
.auth .wrapper-fampe .learn-more .content {
  position: relative;
  width: 100%;
  height: 100%;
  transform: skewX(10deg);
  color: var(--sebrae-blue-6);
  display: flex;
  align-items: center;
}
.auth .wrapper-fampe .learn-more .content figure {
  position: absolute;
  top: -40px;
  right: -12px;
  width: 90px;
}
.auth .wrapper-fampe .learn-more .content h4 {
  font-size: 16px;
  font-weight: 700;
  line-height: 1.2;
}
.auth .wrapper-fampe .learn-more .content p {
  font-size: 11px;
  line-height: 1.4;
}
@media screen and (min-width: 320px) {
  .auth .call-for-access .BaSe--button {
    max-width: 100%;
  }
  .auth .highlight .internal-call-for-access {
    display: none;
  }
}
@media screen and (min-width: 375px) {
  .auth .highlight__logo {
    max-width: 311px;
  }
  .auth .carousel.mobile .card-projected {
    min-height: 202px;
  }
  .auth .wrapper-fampe .learn-more {
    padding: 15px 20px;
  }
}
@media screen and (min-width: 768px) {
  .auth .title-section {
    font-size: 30px;
    text-align: center;
    margin-bottom: 30px;
  }
  .auth .call-for-access h2 {
    font-size: 24px;
  }
  .auth .call-for-access .BaSe--button {
    margin: 0 0 0 auto;
  }
  .auth .mockup-finances p {
    font-size: 20px;
    max-width: 392px;
    width: 100%;
  }
  .auth .mockup-finances .title-section {
    display: none;
  }
  .auth .mockup-finances .info-mockup {
    display: flex;
    align-items: center;
    justify-content: center;
    gap: 24px;
  }
  .auth .mockup-finances .info-mockup__text-area {
    max-width: 392px;
  }
  .auth .mockup-finances .info-mockup__text-area h2 {
    display: block !important;
    font-size: 19px;
    font-weight: 700;
    margin-bottom: 16px;
  }
  .auth .mockup-finances .info-mockup__text-area p {
    font-size: 13px;
    font-weight: 400;
  }
  .auth .mockup-finances .info-mockup figure {
    width: 100%;
    max-width: 428px;
  }
  .auth .carousel {
    margin-bottom: 43px;
  }
  .auth .carousel.mobile {
    display: none;
  }
  .auth .carousel.desktop {
    display: flex;
  }
  .auth .wrapper-fampe .fampe {
    position: relative;
    display: flex;
    flex-direction: row-reverse;
    background-color: var(--sebrae-dark-green);
    width: calc(100% - 8px);
    max-width: 802px;
    margin: 0 auto 30px 8px;
  }
  .auth .wrapper-fampe .fampe figure {
    margin: 0;
  }
  .auth .wrapper-fampe .fampe .text {
    width: 100%;
  }
  .auth .wrapper-fampe .fampe .text:before {
    display: none;
  }
  .auth .wrapper-fampe .fampe:before {
    content: "";
    position: absolute;
    z-index: -1;
    top: 8px;
    left: -8px;
    width: 100%;
    height: 100%;
    border: 1px solid var(--sebrae-light-green3);
    display: block;
  }
  .auth .wrapper-fampe .learn-more {
    width: 100%;
    max-width: 390px;
    margin: 70px auto 0;
  }
  .auth .wrapper-button-fixed.auth {
    display: none;
  }
}
@media screen and (min-width: 992px) {
  .auth .highlight__logo {
    display: none;
  }
  .auth .highlight .internal-call-for-access {
    position: absolute;
    top: 50%;
    gap: 48px;
    left: 70px;
    z-index: 2;
    display: flex;
    max-width: 585px;
    align-items: center;
    flex-direction: column;
    justify-content: center;
    transform: translateY(-50%);
  }
  .auth .highlight .internal-call-for-access button {
    max-width: 327px;
  }
  .auth .highlight .internal-call-for-access button span {
    font-size: 19px;
    font-weight: 700;
  }
  .auth .highlight .internal-call-for-access__text {
    font-size: 32px;
    font-weight: 400;
    text-align: center;
    color: var(--sebrae-white);
    text-shadow: 0px 4px 4px rgba(0, 0, 0, 0.25);
  }
  .auth .highlight .internal-call-for-access .logo {
    max-width: 479px;
  }
  .auth .call-for-access {
    display: none;
  }
  .auth .mockup-finances {
    padding-top: 56px;
  }
}
@media screen and (min-width: 1024px) {
  .auth .wrapper-cards {
    padding: 81.6px 0 48px;
  }
  .auth .carousel {
    margin-bottom: 30px;
  }
  .auth .wrapper-fampe {
    display: flex;
    gap: 24px;
    padding-left: 8px;
  }
  .auth .wrapper-fampe .fampe {
    width: calc(66.66666667% + 8px);
    margin: 0;
  }
  .auth .wrapper-fampe .wrapper-learn-more {
    width: calc(33.33333333% - 8px);
    padding: 0 15px;
  }
  .auth .wrapper-fampe .wrapper-learn-more .learn-more {
    margin: 0;
    padding: 18px 15px 15px;
    height: 100%;
  }
}
@media screen and (min-width: 1280px) {
  .auth .title-section {
    font-size: 33px;
    margin-bottom: 32px;
  }
  .auth .highlight__logo {
    max-width: 100%;
    bottom: -47px;
  }
  .auth .call-for-access {
    padding: 87px 0 77px;
  }
  .auth .call-for-access h2 {
    font-size: 40px;
    padding-right: 120px;
  }
  .auth .mockup-finances .info-mockup__text-area {
    max-width: 392px;
  }
  .auth .mockup-finances .info-mockup__text-area h2 {
    font-size: 33px;
    font-weight: 700;
    margin-bottom: 32px;
  }
  .auth .mockup-finances .info-mockup__text-area p {
    font-size: 27px;
    font-weight: 400;
  }
  .auth .carousel {
    margin-bottom: 43px;
  }
  .auth .wrapper-fampe {
    display: flex;
    gap: 24px;
    padding-left: 8px;
  }
  .auth .wrapper-fampe .fampe figure img {
    width: 100%;
    height: 100%;
    object-fit: cover;
    object-position: right;
  }
  .auth .wrapper-fampe .fampe .text {
    max-width: 375px;
  }
  .auth .wrapper-fampe .fampe .text p {
    font-size: 16px;
  }
  .auth .wrapper-fampe .wrapper-learn-more .learn-more {
    padding: 80px 15px 30px 30px;
  }
  .auth .wrapper-fampe .wrapper-learn-more .learn-more .content figure {
    top: -112px;
    width: 124px;
  }
  .auth .wrapper-fampe .wrapper-learn-more .learn-more .content h4 {
    font-size: 20px;
  }
  .auth .wrapper-fampe .wrapper-learn-more .learn-more .content p {
    font-size: 16px;
  }
}`, "",{"version":3,"sources":["webpack://./src/pages/auth/index.scss"],"names":[],"mappings":"AACE;EACE,yBAAA;EAEE,eAAA;EACA,gBAAA;EAEF,gBAAA;EACA,mBAAA;AAFJ;AAIE;EACE,kBAAA;EACA,WAAA;EACA,aAAA;EACA,uBAAA;EACA,qBAAA;AAFJ;AAII;EACE,iBAAA;EACA,gBAAA;AAFN;AAIM;EACE,iBAAA;EACA,iBAAA;AAFR;AAKI;EACE,kBAAA;EACA,aAAA;EACA,UAAA;EACA,gBAAA;AAHN;AAME;EACE,oBAAA;AAJJ;AAMI;EACE,0BAAA;EACA,eAAA;EACA,gBAAA;AAJN;AAMI;EACE,mBAAA;AAJN;AAMI;EACE,gBAAA;AAJN;AAMM;EACE,eAAA;EACA,gBAAA;AAJR;AAQE;EACE,yBAAA;EACA,mBAAA;AANJ;AAQI;EACE,eAAA;EACA,gBAAA;EACA,mBAAA;AANN;AASI;EACE,aAAA;EACA,mBAAA;EACA,sBAAA;EACA,eAAA;AAPN;AAUQ;EACE,aAAA;EACA,uBAAA;AARV;AAYU;EACE,aAAA;AAVZ;AAgBE;EACE,oBAAA;AAdJ;AAgBE;EACE,mBAAA;AAdJ;AAgBI;EACE,eAAA;AAdN;AAgBM;EACE,mBAAA;EACA,iBAAA;AAdR;AAkBU;EACE,iBAAA;AAhBZ;AAqBI;EACE,aAAA;EACA,SAAA;AAnBN;AAuBI;EACE,mBAAA;AArBN;AAuBM;EACE,mBAAA;AArBR;AAuBM;EACE,kBAAA;EACA,uBAAA;EACA,0CAAA;EACA,YAAA;EACA,kBAAA;EACA,gBAAA;EACA,kBAAA;EACA,0BAAA;AArBR;AAuBQ;EACE,eAAA;EACA,mBAAA;EACA,gBAAA;AArBV;AAuBQ;EACE,cAAA;EACA,aAAA;EACA,0BAAA;AArBV;AAwBQ;EACE,WAAA;EACA,kBAAA;EACA,WAAA;EACA,QAAA;EACA,UAAA;EACA,WAAA;EACA,YAAA;EACA,4CAAA;EACA,cAAA;AAtBV;AA0BI;EACE,UAAA;EACA,qCAAA;EACA,aAAA;EACA,wBAAA;EACA,mBAAA;AAxBN;AA0BM;EACE,kBAAA;EACA,WAAA;EACA,YAAA;EACA,uBAAA;EACA,2BAAA;EACA,aAAA;EACA,mBAAA;AAxBR;AA0BQ;EACE,kBAAA;EACA,UAAA;EACA,YAAA;EACA,WAAA;AAxBV;AA0BQ;EAEI,eAAA;EACA,gBAAA;EAEF,gBAAA;AA1BV;AA4BQ;EACE,eAAA;EACA,gBAAA;AA1BV;AAgCE;EAEI;IACE,eAAA;EA/BN;EAoCI;IACE,aAAA;EAlCN;AACF;AAsCE;EACE;IACE,gBAAA;EApCJ;EAwCM;IACE,iBAAA;EAtCR;EA2CI;IACE,kBAAA;EAzCN;AACF;AA4CE;EACE;IACE,eAAA;IACA,kBAAA;IACA,mBAAA;EA1CJ;EA6CI;IACE,eAAA;EA3CN;EA6CI;IACE,kBAAA;EA3CN;EA+CI;IACE,eAAA;IACA,gBAAA;IACA,WAAA;EA7CN;EA+CI;IACE,aAAA;EA7CN;EAgDI;IACE,aAAA;IACA,mBAAA;IACA,uBAAA;IACA,SAAA;EA9CN;EAgDM;IACE,gBAAA;EA9CR;EAgDQ;IACE,yBAAA;IACA,eAAA;IACA,gBAAA;IACA,mBAAA;EA9CV;EAiDQ;IACE,eAAA;IACA,gBAAA;EA/CV;EAmDM;IACE,WAAA;IACA,gBAAA;EAjDR;EAqDE;IACE,mBAAA;EAnDJ;EAqDI;IACE,aAAA;EAnDN;EAqDI;IACE,aAAA;EAnDN;EAuDI;IACE,kBAAA;IACA,aAAA;IACA,2BAAA;IACA,0CAAA;IACA,uBAAA;IACA,gBAAA;IACA,uBAAA;EArDN;EAuDM;IACE,SAAA;EArDR;EAuDM;IACE,WAAA;EArDR;EAuDQ;IACE,aAAA;EArDV;EAwDM;IACE,WAAA;IACA,kBAAA;IACA,WAAA;IACA,QAAA;IACA,UAAA;IACA,WAAA;IACA,YAAA;IACA,4CAAA;IACA,cAAA;EAtDR;EAyDI;IACE,WAAA;IACA,gBAAA;IACA,mBAAA;EAvDN;EA0DE;IACE,aAAA;EAxDJ;AACF;AA0DE;EAEI;IACE,aAAA;EAzDN;EA4DI;IACE,kBAAA;IACA,QAAA;IACA,SAAA;IACA,UAAA;IACA,UAAA;IACA,aAAA;IACA,gBAAA;IACA,mBAAA;IACA,sBAAA;IACA,uBAAA;IACA,2BAAA;EA1DN;EA4DM;IACE,gBAAA;EA1DR;EA4DQ;IACE,eAAA;IACA,gBAAA;EA1DV;EA8DM;IACE,eAAA;IACA,gBAAA;IACA,kBAAA;IACA,0BAAA;IACA,4CAAA;EA5DR;EA+DM;IACE,gBAAA;EA7DR;EAkEE;IACE,aAAA;EAhEJ;EAmEE;IACE,iBAAA;EAjEJ;AACF;AAmEE;EACE;IACE,sBAAA;EAjEJ;EAmEE;IACE,mBAAA;EAjEJ;EAmEE;IACE,aAAA;IACA,SAAA;IACA,iBAAA;EAjEJ;EAmEI;IACE,+BAAA;IACA,SAAA;EAjEN;EAmEI;IACE,+BAAA;IACA,eAAA;EAjEN;EAmEM;IACE,SAAA;IACA,uBAAA;IACA,YAAA;EAjER;AACF;AAqEE;EACE;IACE,eAAA;IACA,mBAAA;EAnEJ;EAqEE;IACE,eAAA;IACA,aAAA;EAnEJ;EAqEE;IACE,oBAAA;EAnEJ;EAoEI;IACE,eAAA;IACA,oBAAA;EAlEN;EAyEM;IACE,gBAAA;EAvER;EAyEQ;IACE,eAAA;IACA,gBAAA;IACA,mBAAA;EAvEV;EA0EQ;IACE,eAAA;IACA,gBAAA;EAxEV;EA6EE;IACE,mBAAA;EA3EJ;EA6EE;IACE,aAAA;IACA,SAAA;IACA,iBAAA;EA3EJ;EA8EM;IACE,WAAA;IACA,YAAA;IACA,iBAAA;IACA,sBAAA;EA5ER;EA8EM;IACE,gBAAA;EA5ER;EA8EQ;IACE,eAAA;EA5EV;EAiFM;IACE,4BAAA;EA/ER;EAkFU;IACE,WAAA;IACA,YAAA;EAhFZ;EAkFU;IACE,eAAA;EAhFZ;EAkFU;IACE,eAAA;EAhFZ;AACF","sourcesContent":[".auth {\r\n  .title-section {\r\n    color: var(--sebrae-gray);\r\n    font: {\r\n      size: 19px;\r\n      weight: 700;\r\n    }\r\n    line-height: 1.2;\r\n    margin-bottom: 16px;\r\n  }\r\n  .highlight {\r\n    position: relative;\r\n    width: 100%;\r\n    display: flex;\r\n    justify-content: center;\r\n    align-items: flex-end;\r\n\r\n    &__img {\r\n      max-height: 603px;\r\n      overflow: hidden;\r\n\r\n      img {\r\n        min-height: 202px;\r\n        object-fit: cover;\r\n      }\r\n    }\r\n    &__logo {\r\n      position: absolute;\r\n      bottom: -24px;\r\n      z-index: 1;\r\n      max-width: 290px;\r\n    }\r\n  }\r\n  .call-for-access {\r\n    padding: 50px 0 40px;\r\n\r\n    h2 {\r\n      color: var(--sebrae-lilac);\r\n      font-size: 16px;\r\n      line-height: 1.2;\r\n    }\r\n    .BaSe--grid {\r\n      align-items: center;\r\n    }\r\n    .BaSe--button {\r\n      max-width: 327px;\r\n\r\n      span {\r\n        font-size: 16px;\r\n        font-weight: 700;\r\n      }\r\n    }\r\n  }\r\n  .mockup-finances {\r\n    color: var(--sebrae-gray);\r\n    padding-bottom: 8px;\r\n\r\n    p {\r\n      font-size: 13px;\r\n      line-height: 1.2;\r\n      margin-bottom: 24px;\r\n    }\r\n\r\n    .container {\r\n      display: flex;\r\n      align-items: center;\r\n      flex-direction: column;\r\n      padding: 0 24px;\r\n\r\n      .info-mockup {\r\n        figure {\r\n          display: flex;\r\n          justify-content: center;\r\n        }\r\n\r\n        &__text-area {\r\n          h2 {\r\n            display: none;\r\n          }\r\n        }\r\n      }\r\n    }\r\n  }\r\n  .wrapper-cards {\r\n    padding: 40px 0 48px;\r\n  }\r\n  .carousel {\r\n    margin-bottom: 49px;\r\n\r\n    &.mobile {\r\n      margin: 0 -16px;\r\n\r\n      .card-projected {\r\n        margin: 0 10px 15px;\r\n        min-height: 240px;\r\n      }\r\n      .slick-slide {\r\n        &:first-of-type {\r\n          .card-projected {\r\n            margin-left: 16px;\r\n          }\r\n        }\r\n      }\r\n    }\r\n    &.desktop {\r\n      display: none;\r\n      gap: 24px;\r\n    }\r\n  }\r\n  .wrapper-fampe {\r\n    .fampe {\r\n      margin-bottom: 24px;\r\n\r\n      figure {\r\n        margin-bottom: 16px;\r\n      }\r\n      .text {\r\n        position: relative;\r\n        width: calc(100% - 8px);\r\n        background-color: var(--sebrae-dark-green);\r\n        height: auto;\r\n        padding: 16px 15px;\r\n        margin-left: 8px;\r\n        margin-bottom: 8px;\r\n        color: var(--sebrae-white);\r\n\r\n        p {\r\n          font-size: 13px;\r\n          margin-bottom: 20px;\r\n          line-height: 1.2;\r\n        }\r\n        a {\r\n          color: inherit;\r\n          font: inherit;\r\n          text-decoration: underline;\r\n        }\r\n\r\n        &:before {\r\n          content: \"\";\r\n          position: absolute;\r\n          z-index: -1;\r\n          top: 8px;\r\n          left: -8px;\r\n          width: 100%;\r\n          height: 100%;\r\n          border: 1px solid var(--sebrae-light-green3);\r\n          display: block;\r\n        }\r\n      }\r\n    }\r\n    .learn-more {\r\n      width: 90%;\r\n      border: 1px solid var(--sebrae-lilac);\r\n      padding: 15px;\r\n      transform: skewX(-10deg);\r\n      margin: 47px auto 0;\r\n\r\n      .content {\r\n        position: relative;\r\n        width: 100%;\r\n        height: 100%;\r\n        transform: skewX(10deg);\r\n        color: var(--sebrae-blue-6);\r\n        display: flex;\r\n        align-items: center;\r\n\r\n        figure {\r\n          position: absolute;\r\n          top: -40px;\r\n          right: -12px;\r\n          width: 90px;\r\n        }\r\n        h4 {\r\n          font: {\r\n            size: 16px;\r\n            weight: 700;\r\n          }\r\n          line-height: 1.2;\r\n        }\r\n        p {\r\n          font-size: 11px;\r\n          line-height: 1.4;\r\n        }\r\n      }\r\n    }\r\n  }\r\n\r\n  @media screen and (min-width: 320px) {\r\n    .call-for-access {\r\n      .BaSe--button {\r\n        max-width: 100%;\r\n      }\r\n    }\r\n\r\n    .highlight {\r\n      .internal-call-for-access {\r\n        display: none;\r\n      }\r\n    }\r\n  }\r\n\r\n  @media screen and (min-width: 375px) {\r\n    .highlight__logo {\r\n      max-width: 311px;\r\n    }\r\n    .carousel {\r\n      &.mobile {\r\n        .card-projected {\r\n          min-height: 202px;\r\n        }\r\n      }\r\n    }\r\n    .wrapper-fampe {\r\n      .learn-more {\r\n        padding: 15px 20px;\r\n      }\r\n    }\r\n  }\r\n  @media screen and (min-width: 768px) {\r\n    .title-section {\r\n      font-size: 30px;\r\n      text-align: center;\r\n      margin-bottom: 30px;\r\n    }\r\n    .call-for-access {\r\n      h2 {\r\n        font-size: 24px;\r\n      }\r\n      .BaSe--button {\r\n        margin: 0 0 0 auto;\r\n      }\r\n    }\r\n    .mockup-finances {\r\n      p {\r\n        font-size: 20px;\r\n        max-width: 392px;\r\n        width: 100%;\r\n      }\r\n      .title-section {\r\n        display: none;\r\n      }\r\n\r\n      .info-mockup {\r\n        display: flex;\r\n        align-items: center;\r\n        justify-content: center;\r\n        gap: 24px;\r\n\r\n        &__text-area {\r\n          max-width: 392px;\r\n\r\n          h2 {\r\n            display: block !important;\r\n            font-size: 19px;\r\n            font-weight: 700;\r\n            margin-bottom: 16px;\r\n          }\r\n\r\n          p {\r\n            font-size: 13px;\r\n            font-weight: 400;\r\n          }\r\n        }\r\n\r\n        figure {\r\n          width: 100%;\r\n          max-width: 428px;\r\n        }\r\n      }\r\n    }\r\n    .carousel {\r\n      margin-bottom: 43px;\r\n\r\n      &.mobile {\r\n        display: none;\r\n      }\r\n      &.desktop {\r\n        display: flex;\r\n      }\r\n    }\r\n    .wrapper-fampe {\r\n      .fampe {\r\n        position: relative;\r\n        display: flex;\r\n        flex-direction: row-reverse;\r\n        background-color: var(--sebrae-dark-green);\r\n        width: calc(100% - 8px);\r\n        max-width: 802px;\r\n        margin: 0 auto 30px 8px;\r\n\r\n        figure {\r\n          margin: 0;\r\n        }\r\n        .text {\r\n          width: 100%;\r\n\r\n          &:before {\r\n            display: none;\r\n          }\r\n        }\r\n        &:before {\r\n          content: \"\";\r\n          position: absolute;\r\n          z-index: -1;\r\n          top: 8px;\r\n          left: -8px;\r\n          width: 100%;\r\n          height: 100%;\r\n          border: 1px solid var(--sebrae-light-green3);\r\n          display: block;\r\n        }\r\n      }\r\n      .learn-more {\r\n        width: 100%;\r\n        max-width: 390px;\r\n        margin: 70px auto 0;\r\n      }\r\n    }\r\n    .wrapper-button-fixed.auth {\r\n      display: none;\r\n    }\r\n  }\r\n  @media screen and (min-width: 992px) {\r\n    .highlight {\r\n      &__logo {\r\n        display: none;\r\n      }\r\n\r\n      .internal-call-for-access {\r\n        position: absolute;\r\n        top: 50%;\r\n        gap: 48px;\r\n        left: 70px;\r\n        z-index: 2;\r\n        display: flex;\r\n        max-width: 585px;\r\n        align-items: center;\r\n        flex-direction: column;\r\n        justify-content: center;\r\n        transform: translateY(-50%);\r\n\r\n        button {\r\n          max-width: 327px;\r\n\r\n          span {\r\n            font-size: 19px;\r\n            font-weight: 700;\r\n          }\r\n        }\r\n\r\n        &__text {\r\n          font-size: 32px;\r\n          font-weight: 400;\r\n          text-align: center;\r\n          color: var(--sebrae-white);\r\n          text-shadow: 0px 4px 4px rgba(0, 0, 0, 0.25);\r\n        }\r\n\r\n        .logo {\r\n          max-width: 479px;\r\n        }\r\n      }\r\n    }\r\n\r\n    .call-for-access {\r\n      display: none;\r\n    }\r\n\r\n    .mockup-finances {\r\n      padding-top: 56px;\r\n    }\r\n  }\r\n  @media screen and (min-width: 1024px) {\r\n    .wrapper-cards {\r\n      padding: 81.6px 0 48px;\r\n    }\r\n    .carousel {\r\n      margin-bottom: 30px;\r\n    }\r\n    .wrapper-fampe {\r\n      display: flex;\r\n      gap: 24px;\r\n      padding-left: 8px;\r\n\r\n      .fampe {\r\n        width: calc(66.66666667% + 8px);\r\n        margin: 0;\r\n      }\r\n      .wrapper-learn-more {\r\n        width: calc(33.33333333% - 8px);\r\n        padding: 0 15px;\r\n\r\n        .learn-more {\r\n          margin: 0;\r\n          padding: 18px 15px 15px;\r\n          height: 100%;\r\n        }\r\n      }\r\n    }\r\n  }\r\n  @media screen and (min-width: 1280px) {\r\n    .title-section {\r\n      font-size: 33px;\r\n      margin-bottom: 32px;\r\n    }\r\n    .highlight__logo {\r\n      max-width: 100%;\r\n      bottom: -47px;\r\n    }\r\n    .call-for-access {\r\n      padding: 87px 0 77px;\r\n      h2 {\r\n        font-size: 40px;\r\n        padding-right: 120px;\r\n      }\r\n      .BaSe--button {\r\n      }\r\n    }\r\n    .mockup-finances {\r\n      .info-mockup {\r\n        &__text-area {\r\n          max-width: 392px;\r\n\r\n          h2 {\r\n            font-size: 33px;\r\n            font-weight: 700;\r\n            margin-bottom: 32px;\r\n          }\r\n\r\n          p {\r\n            font-size: 27px;\r\n            font-weight: 400;\r\n          }\r\n        }\r\n      }\r\n    }\r\n    .carousel {\r\n      margin-bottom: 43px;\r\n    }\r\n    .wrapper-fampe {\r\n      display: flex;\r\n      gap: 24px;\r\n      padding-left: 8px;\r\n\r\n      .fampe {\r\n        figure img {\r\n          width: 100%;\r\n          height: 100%;\r\n          object-fit: cover;\r\n          object-position: right;\r\n        }\r\n        .text {\r\n          max-width: 375px;\r\n\r\n          p {\r\n            font-size: 16px;\r\n          }\r\n        }\r\n      }\r\n      .wrapper-learn-more {\r\n        .learn-more {\r\n          padding: 80px 15px 30px 30px;\r\n\r\n          .content {\r\n            figure {\r\n              top: -112px;\r\n              width: 124px;\r\n            }\r\n            h4 {\r\n              font-size: 20px;\r\n            }\r\n            p {\r\n              font-size: 16px;\r\n            }\r\n          }\r\n        }\r\n      }\r\n    }\r\n  }\r\n}\r\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
